/**
 * 物业管理首页
 */
import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import Swiper from 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.min.css'
import './Management.css'
import {List, Icon, Skeleton, message} from 'antd'
import {fetchGet, fetchPost} from "../../../utils/fetchRequest";
import {_baseURL, API} from "../../../configs/api.config";
import {Toast} from "antd-mobile";
import {connect} from 'react-redux'
import {saveListState} from "../../../redux/actions/listState";
import nodata_img from "../../../style/imgs/no_data.png";
import icon_repair from "../../../style/imgs/repair_img.png";

let mySwiper;

class Management extends Component {

    constructor() {
        super();
        this.state = {
            selectIndex: -1,
            parentList0: [],
            parentList1: [],
            parentList2: [],
            parentList: [],
            isPhonesLoading: true,
            isClassLoading: true,
            isRefreshing: false,
        }
    }

    componentDidMount() {
        document.title = '我的维修申请';
        const that = this;
        const {selectIndex} = this.state;

        mySwiper = new Swiper('.swiper-container', {
            autoplay: false,
            loop: false,
            on: {
                slideChangeTransitionEnd: function () {
                    that.setState({
                        selectIndex: this.activeIndex
                    })
                }
            }
        });

        if (this.props.listState.tabIndex >= 0) {
            this.setState({
                selectIndex: this.props.listState.tabIndex
            }, () => {
                mySwiper.slideTo(this.state.selectIndex, 0, false)
            })
        }

        //this.getTeacherPhones();
        this.getClassList()

    }

    render() {
        const {
            selectIndex, parentList, isClassLoading, parentList0, parentList1, parentList2
        } = this.state;

        const parentItems =
            <Skeleton loading={isClassLoading} active paragraph={{rows: 3}}>
            <List dataSource={parentList} renderItem={
                (item, index) => (
                    <div style={{padding:10,paddingBottom:0}}>
                    <List.Item style={{"padding": "0px"}}>
                        <div className='item-Style'
                         onClick={this.onParentItemClick.bind(this, index)}>
                            <div style={{width:'18%'}}>
                                <div style={{width:76,height:'100%'}}>
                                    <img src={icon_repair} className={"img_sty"}/>
                                </div>
                            </div>
                            <div style={{width:'65%'}}>
                                <div style={{color:"#333333",fontSize:15,marginTop:10}}>
                                    维修申请
                                </div>
                                {console.log("item",item)}
                                <div style={{color:"#666666",fontSize:12,marginTop:5}}>{item.repairsTime}</div>
                            </div>
                            <div className={item.state === 2 ?'done':'doing'}
                                 style={{textAlign:'left',marginTop:10,fontSize:12,width:'15%'}}>
                                {item.state === 0 ? "待分配" : item.state === 1 ? "维修中" : item.state === 2 ? "已处理" : ''}
                            </div>
                        </div>
                    </List.Item>
                    </div>
                )}/>
        </Skeleton>;
        const parentItems0 =
            <Skeleton loading={isClassLoading} active paragraph={{rows: 3}}>
            <List dataSource={parentList0} renderItem={
                (item, index) => (
                    <div style={{padding:10,paddingBottom:0}}>
                    <List.Item style={{padding:0}}>
                        <div className='item-Style'
                             onClick={this.onParentItemClick0.bind(this, index)}>
                            <div style={{width:'18%'}}>
                                <div style={{width:76,height:'100%'}}>
                                    <img src={icon_repair} className={"img_sty"}/>
                                </div>
                            </div>
                            <div style={{width:'65%'}}>
                                <div style={{color:"#333333",fontSize:15,marginTop:10}}>
                                    维修申请
                                </div>
                                <div style={{color:"#666666",fontSize:12,marginTop:5}}>{item.repairsTime}</div>
                            </div>
                            <div className={item.state === 2 ?'done':'doing'}
                                 style={{textAlign:'left',marginTop:10,fontSize:12,width:'15%'}}>
                                {item.state === 0 ? "待分配" : item.state === 1 ? "维修中" : item.state === 2 ? "已处理" : ''}
                            </div>
                        </div>
                    </List.Item>
                    </div>
                )}/>
        </Skeleton>;
        const parentItems1 =
            <Skeleton loading={isClassLoading} active paragraph={{rows: 3}}>
            <List dataSource={parentList1} renderItem={
                (item, index) => (
                    <div style={{padding:10,paddingBottom:0}}>
                    <List.Item style={{padding:0}}>
                        <div className='item-Style'
                             onClick={this.onParentItemClick1.bind(this, index)}>
                             <div style={{width:'18%'}}>
                                 <div style={{width:76,height:'100%'}}>
                                     <img src={icon_repair} className={"img_sty"}/>
                                 </div>
                             </div>
                             <div style={{width:'65%'}}>
                                 <div style={{color:"#333333",fontSize:15,marginTop:10}}>
                                     维修申请
                                 </div>
                                 <div style={{color:"#666666",fontSize:12,marginTop:5}}>{item.repairsTime}</div>
                             </div>
                             <div className={item.state === 2 ?'done':'doing'}
                                  style={{textAlign:'left',marginTop:10,fontSize:12,width:'15%'}}>
                                 {item.state === 0 ? "待分配" : item.state === 1 ? "维修中" : item.state === 2 ? "已处理" : ''}
                             </div>
                        </div>
                    </List.Item>
                    </div>
                )}/>
        </Skeleton>;
        const parentItems2 =
            <Skeleton loading={isClassLoading} active paragraph={{rows: 3}}>
            <List dataSource={parentList2} renderItem={
                (item, index) => (
                    <div style={{padding:10,paddingBottom:0}}>
                    <List.Item style={{padding:0}}>
                        <div className='item-Style'
                             onClick={this.onParentItemClick2.bind(this, index)}>
                            <div style={{width:'18%'}}>
                                <div style={{width:76,height:'100%'}}>
                                    <img src={icon_repair} className={"img_sty"}/>
                                </div>
                            </div>
                            <div style={{width:'65%'}}>
                                <div style={{color:"#333333",fontSize:15,marginTop:10}}>
                                    维修申请
                                </div>
                                <div style={{color:"#666666",fontSize:12,marginTop:5}}>{item.repairsTime}</div>
                            </div>
                            <div className={item.state === 2 ?'done':'doing'}
                                 style={{textAlign:'left',marginTop:10,fontSize:12,width:'15%'}}>
                                {item.state === 0 ? "待分配" : item.state === 1 ? "维修中" : item.state === 2 ? "已处理" : ''}
                            </div>
                        </div>
                    </List.Item>
                    </div>
                )}/>
        </Skeleton>;

        return (
            <div className='phone-select-root'>
                <div className='gray-line'></div>
                <div className='identity-select'>
                    <div style={{fontSize:15}} className={selectIndex === -1 ?
                        'states-item-select' : 'states-item-normal'}
                         onClick={this.onMyClick}>我的申请
                    </div>
                    <div className={selectIndex === 0 ?
                        'states-item-select' : 'states-item-normal'}
                         onClick={this.onStayClick}>待分配
                    </div>
                    <div className={selectIndex === 1 ?
                        'states-item-select' : 'states-item-normal'}
                         onClick={this.onOngoingClick}>维修中
                    </div>
                    <div className={selectIndex === 2 ?
                        'states-item-select' : 'states-item-normal'}
                         onClick={this.onEndClick}>已处理
                    </div>
                </div>
                <div className="swiper-container" style={{backgroundColor: "#F2F2F2"}}
                     ref={el => {
                         this.contain1 = el
                     }}>
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <div className='swiper-content'>
                                {
                                    selectIndex === -1?parentItems:(selectIndex === 0?parentItems0:(selectIndex === 1?parentItems1:selectIndex === 2?parentItems2:
                                    <div className="no_data"><img src={nodata_img} alt="" style={{width:'100%',height:'100%'}}/></div>))
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Icon type="plus-circle" theme='filled' className='common-add-icon'
                      onClick={this.onAddNotify}/>
                {/*{detailModal}*/}
            </div>
        )
    }

    onAddNotify = () => {
        // this.saveListStatus(true, null)
        this.props.history.push('/repairApply')
    }

    getClassList = () => {
        const {parentList} = this.state;
        const {parentList0} = this.state;
        const {parentList1} = this.state;
        const {parentList2} = this.state;

        let url = API.GET_MAINTENANCE_LIST;
        let params = {
            teacherId: this.props.userInfo.user.userFunId
        };

        fetchGet(url, params).then(response => {
            Toast.hide();

            if (response && response.data) {
                response.data.map((item, index) => {
                    item.md_teacherId.forEach((node, index) => {
                        if(item.state === 0 && node === this.props.userInfo.teacher.teacherId){
                            parentList0.push(item)
                        }
                    });
                    if(item.state === 1 && item.mi_teacherId === this.props.userInfo.teacher.teacherId){
                        parentList1.push(item)
                    }
                    if(item.state === 2){
                        parentList2.push(item)
                    }
                    if(item.proposer === this.props.userInfo.teacher.teacherId){
                        parentList.push(item)
                    }
                    // parentList.push(item)
                });

                this.setState({
                    parentList,
                    parentList0,
                    parentList1,
                    parentList2,
                    isClassLoading: false
                })
            }

        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                message.error(error)
            }

            this.setState({
                isClassLoading: false
            })
        })
    };

   /* getTeacherPhones = () => {
        mPageIndex++;

        try {
            this.setState({
                isRefreshing: true
            })
        } catch (e) {

        }

        const {teacherList} = this.state;
        if (mPageIndex === 1) {
            teacherList.length = 0
        }

        fetchPost(API.GET_MAINTENANCE_LIST, {
            teacherId: this.props.userInfo.teacher.teacherId,
            selectKey: '',
            pageIndex: mPageIndex,
            pageSize: mPageSize
        }).then(response => {
            Toast.hide();

            if (response && response.data && response.data.length > 0) {
                response.data.map((item, index) => {
                    let phoneBean = new PhonesBean();
                    phoneBean.icon = require('imgs/ic_head' + (index % 15 + 1) + '.png');
                    phoneBean.icon = getStrValue(item, 'teacherPhoto');
                    phoneBean.name = getStrValue(item, 'proposerName');
                    phoneBean.phone = [getStrValue(item, 'userPhone')];
                    // phoneBean.claName = getStrValue(item, 'schName')
                    phoneBean.children = [''];

                    teacherList.push(phoneBean)
                })
            } else {
                if (mPageIndex > 1) {
                    mPageIndex--
                }
            }

            this.setState({
                teacherList,
                isPhonesLoading: false,
                isRefreshing: false,
            })

        }).catch(error => {
            Toast.hide();

            if (mPageIndex > 1) {
                mPageIndex--
            }
            this.setState({
                isRefreshing: false,
                isPhonesLoading: false,
            });
            if (typeof error === 'string') {
                message.error(error)
            }
        })
    };*/

    onParentItemClick = (index) => {
        const {parentList} = this.state;
        let selectItem = parentList[index];
        console.log("selectItem",selectItem)
        this.props.history.push('/managementList/maintenance/' + selectItem.id)
    };
    onParentItemClick0 = (index) => {
        const {parentList0} = this.state;
        let selectItem0 = parentList0[index];
        this.props.history.push('/managementList/maintenance/' + selectItem0.id)
    };
    onParentItemClick1 = (index) => {
        const {parentList1} = this.state;
        let selectItem1 = parentList1[index];
        this.props.history.push('/managementList/maintenance/' + selectItem1.id)
    };
    onParentItemClick2 = (index) => {
        const {parentList2} = this.state;
        let selectItem2 = parentList2[index];
        this.props.history.push('/managementList/maintenance/' + selectItem2.id)
    };

    onMyClick = () => {
        this.setState({
            selectIndex: -1
        }, () => {
            mySwiper.slideTo(this.state.selectIndex, 300, false)

            saveListState({
                tabIndex: this.state.selectIndex,
            })()
        })
    };

    onStayClick = () => {
        this.setState({
            selectIndex: 0
        }, () => {
            mySwiper.slideTo(this.state.selectIndex, 300, false);

            saveListState({
                tabIndex: this.state.selectIndex,
            })()
        })
    };
    onOngoingClick = () => {
        this.setState({
            selectIndex: 1
        }, () => {
            mySwiper.slideTo(this.state.selectIndex, 300, false)

            saveListState({
                tabIndex: this.state.selectIndex,
            })()
        })
    };
    onEndClick = () => {
        this.setState({
            selectIndex: 2
        }, () => {
            mySwiper.slideTo(this.state.selectIndex, 300, false)

            saveListState({
                tabIndex: this.state.selectIndex,
            })()
        })
    }
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
    listState: {...state.redListState}
});

let mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Management)